export const CONSUL = 'consul';
export const ROBOCERT = 'robocert';

export const SSL_PROVIDERS = [
  CONSUL,
  ROBOCERT,
];
